import { render, staticRenderFns } from "./CLazy.vue?vue&type=template&id=1bd4818e"
import script from "./CLazy.vue?vue&type=script&setup=true&lang=ts"
export * from "./CLazy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports